import { agentApiFetch } from "@/lib/agentApiFetch";

/**
 * Loads the signed-in human agent account, including sla_breach_count.
 */
export class AgentMeApi {
  /**
   * @param {{ workspaceId?: string | null }} [opts]
   */
  fetchMe({ workspaceId } = {}) {
    return agentApiFetch("/api/v1/agent/me", { workspaceId });
  }
}

export const agentMeApi = new AgentMeApi();
